/*eslint-disable*/
// useDateDiff.js
import Swal from 'sweetalert2'


export async function isMoreThan24Hours(range) {
    if (!range || range.length < 2) return false
    const [start, end] = range.map(d => new Date(d))
    const diffHours = (Math.abs(end - start) / (1000 * 60 * 60)) - 4

    if (diffHours > 24) {
        const result = await Swal.fire({
            title: "Le nombre de jours est supérieur à 1",
            text: "La recherche peut prendre un certain temps. Êtes-vous sûr de vouloir exécuter la recherche ?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Oui',
            cancelButtonText: 'Non',
        })

        return result.isConfirmed
    } else {
        return true
    }
 
}



export async function isMoreThan24HoursFake(range) {
    return true

}


export async function hasValidDateRange(datePicker) {
    const range = datePicker?.date?.range;
    return (
        Array.isArray(range) &&
        range?.length === 2 &&
        !!range[0] &&
        !!range[1]
    );
}